class ResponseCacher {
  constructor (cacheRetrievalsBeforeClean, keepCachedMs) {
    this.cachedResponses = {}
    this.retrievalCount = 0
    this.cacheRetrievalsBeforeClean = cacheRetrievalsBeforeClean != null ? cacheRetrievalsBeforeClean : 1000
    this.keepCachedMs = keepCachedMs != null ? keepCachedMs : 900000 // 15 minutes in ms
  }

  /**
   * Checks if the key is in cache
   * @param {} key
   */
  isCached (key) {
    return key in this.cachedResponses
  }

  /**
   * Gets a cached value
   * @param {key} key
   */
  getValue (key) {
    this.cachedResponses[key].timestamp = new Date().getTime()
    this.retrievalCount += 1
    if (this.retrievalCount >= this.cacheRetrievalsBeforeClean) {
      this.cleanCache()
      this.retrievalCount = 0
    }
    return this.cachedResponses[key].value
  }

  /**
   * Saves to cache a new value
   * @param {key that identifies the value to be cached} key
   * @param {value to be cached} value
   */
  setValue (key, value) {
    this.cachedResponses[key] = {
      value,
      timestamp: new Date().getTime()
    }
  }

  /**
   * Remove old values from cache
   */
  cleanCache () {
    const now = new Date().getTime()
    const oldAddresses = Object.keys(this.cachedResponses)
      .filter(key => now - this.cachedResponses[key].timestamp > this.keepCachedMs)
    oldAddresses.forEach(key => delete this.cachedResponses[key])
  }
}

export default ResponseCacher



// WEBPACK FOOTER //
// ./src/services/utils/responseCacher.js